export default "__VITE_ASSET__DLbtiISf__"